import { policyRuleTabs } from './constants'

export const getPolicyRuleTabs = (t, summary) => {
  return policyRuleTabs.map(tab => ({
    value: tab.value,
    label: summary ? `${t(tab.label)} (${summary[tab.value]})` : t(tab.label),
  }))
}
